"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var description = 'This is how you get Drawer if you don"t pass any props. ' +
    'Just a empty sidebar with size of the entire screen.';
var code = "import React from 'react';\nimport { Drawer } from 'jsc-react-ui':\n\nconst DrawerExample = () => <Drawer />;";
exports.RawExampleDrawer = function () { return (React.createElement(common_1.Example, { title: "Raw", description: description, code: code },
    React.createElement(components_1.Drawer, null))); };
exports.RawExampleDrawer.displayName = 'RawExampleDrawer';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentDrawerPage/RawExampleDrawer.tsx
// module id = 660
// module chunks = 0